import { render, staticRenderFns } from "./TokenTransfer.vue?vue&type=template&id=d9d01d00&scoped=true&"
import script from "./TokenTransfer.vue?vue&type=script&lang=js&"
export * from "./TokenTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d01d00",
  null
  
)

export default component.exports